import SquareProductLogo from './square-logo-colour.svg';
import SquarespaceProductLogo from './squarespace-logo-colour.svg';
import WixProductLogo from './wix-logo-colour.svg';

export { SquareProductLogo, SquarespaceProductLogo, WixProductLogo };
